;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const notificationQueryKeys = {
	all: ["notifications"] as const,
	list: (workspaceId: string) =>
		[...notificationQueryKeys.all, workspaceId] as const,
	unreadSummary: (workspaceId: string) =>
		[...notificationQueryKeys.list(workspaceId), "unread-summary"] as const,
};

export const notificationMutationKeys = {
	update: (workspaceId: string) =>
		[...notificationQueryKeys.list(workspaceId), "update"] as const,
};
